import script from "./ParentProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentProduct.vue?vue&type=script&setup=true&lang=js"

import "./ParentProduct.vue?vue&type=style&index=0&id=6f0a5f85&lang=scss&scoped=true"

import exportComponent from "D:\\laragon\\www\\moesanpan_pos_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0a5f85"]])

export default __exports__